<h5 class="billing-section-title">
  <mat-icon>credit_card</mat-icon>
  <span class="title-label">Resumen de Facturación</span>
</h5>
<hr>
<ion-row class="billing-content">
  <ion-col size="12">
    <div class="billing-card">
      <h4>Uso de Almacenamiento</h4>
      <div class="chart-container">
        <canvas 
        *ngIf="pieChartData.datasets[0].data.length"
        baseChart 
        [data]="pieChartData" 
        [labels]="pieChartLabels" 
        [type]="pieChartType">
        </canvas>
      </div>
      <div class="progress-label">
        <span>{{ storageUsed.toFixed(1) }} GB / {{ totalStorage }} GB</span>
      </div>
    </div>
  </ion-col>
</ion-row>